<div
  class="sku"
  [ngClass]="{
    'sku--in-box': box,
    'sku--last': isLast,
    'sku--not-movable':
      (sku.totalBoxed === sku.qty ||
      !canEdit ||
      status === 'DRAFT' ||
      selectedAccountType == 'Walmart') || shipmentSkuBoxScan,
    'sku--scan-item': shipmentSkuBoxScan,
    'sku--error': errorMessage,
    'sku--active': active,
    'sku--detail': showDetail  && !shipmentSkuBoxScan,
    'sku--scan-complete': scanComplete,
    'sku--selected': sku.checked
  }"
>
  <div
    class="sku_image"
    [style.backgroundImage]="'url(' + sku.imageUrl + ')'"
  ></div>
  <div
    class="sku_qty"
    [ngClass]="{ 'sku_qty--success': sku.totalBoxed === sku.qty }"
    *ngIf="!box && !shipmentSkuBoxScan"
  >
    <span class="sku_number">
      {{
        selectedAccountType !== "Walmart"
          ?( sku.totalBoxed | number) + " / " + (sku.qty | number)
          : sku.qty
      }}</span
    >
    <span *ngIf="headerService.useBinLocation && sku.pickedQty" class="sku_picked">{{ sku.pickedQty }} Picked</span>
    <div *ngIf="sku.caseQty" [matTooltip]="sku.caseQty + ' per Case'">
      <i class="fal fa-boxes"></i>
    </div>

    <div *ngIf="isComplete" class="font_size_10 text-gray">
      Deduct Qty: {{sku.deductQty || 0}}
    </div>
  </div>

  <div class="sku_checkbox" *ngIf="!box && !shipmentSkuBoxScan"><mat-checkbox class="mat-checkbox-custom" (change)="selectSku($event)" [(ngModel)]="sku.checked" ></mat-checkbox></div>
  <div class="sku_qty sku_qty--bold" *ngIf="(box && !shipmentSkuBoxScan && !isAssignSku)">

    {{ sku.qty | number}}
  </div>
  <div class="sku_header">
    <div
      class="sku_title"
      [matTooltip]="
        !vendorItem && selectedAccountType !== 'Walmart' ? sku.title : null
      "
      [ngClass]="{
        'sku_title--highlighted': highlighted,
        curs: status !== 'DRAFT' && selectedAccountType !== 'Walmart'
      }"
      (click)="itemSelected(sku.sku)"
    >
      {{ sku.title }}
    </div>
    <div class="w-90">
      <app-sku-chip
        *ngIf="vendorItem && sku.name"
        [name]="'Name'"
        [value]="sku.name"
      ></app-sku-chip>
      <app-sku-chip
        *ngIf="sku.sku"
        [name]="'SKU'"
        [value]="sku.sku"
        [link]="
        selectedAccountType === 'Amazon'
          ? 'https://sellercentral.amazon.com/myinventory/inventory?searchTerm=' +
          sku.sku
          : 'https://seller.walmart.com/items-and-inventory/manage-items?filters=%7B%22productOfferId%22%3A%7B%22op%22%3A%22is%22%2C%22value%22%3A%5B%7B%22key%22%3A%22sku%22%2C%22value%22%3A%22' +
          sku.sku +
            '%22%7D%5D%7D%7D'
      "
      ></app-sku-chip>
      <app-sku-chip
        *ngIf="sku.asin"
        [name]="sku.asin === sku.fnSku ? 'ASIN / FNSKU' : 'ASIN'"
        [value]="sku.asin"
        [link]="
        selectedAccountType === 'Amazon'
          ? 'https://amazon.com/dp/' + sku.asin + '?th=1&psc=1'
          : 'https://www.walmart.com/ip/' + sku.asin + '/?selected=true'
      "
      ></app-sku-chip>
      <span *ngIf="(sku.fnSku && sku.asin !== sku.fnSku) && !shipmentSkuBoxScan">
        <app-sku-chip [name]="'FNSKU'" [value]="sku.fnSku"></app-sku-chip>
      </span>
       <span *ngIf="(sku.fnsku && sku.asin !== sku.fnsku) && shipmentSkuBoxScan">
        <app-sku-chip [name]="'FNSKU'" [value]="sku.fnsku"></app-sku-chip>
      </span>
    </div>
  </div>
  <div
    class="sku_action sku_action--error"
    [matTooltip]="errorMessage"
    matTooltipClass="error-tooltip"
    *ngIf="errorMessage"
  >
    <i class="fal fa-exclamation-triangle"></i>
  </div>

  <div *ngIf="sku?.getSkuTagsDto?.length"
  class="sku_action"
  (click)="openAllTag($event)"
>
  <i class="fal fa-tags"></i>
</div>
  <div
    class="sku_action sku_action--note sku_action--edit"
    [matTooltip]="sku.note ? sku.note : 'Add Note'"
    *ngIf="canBox && !shipmentSkuBoxScan"   
  >
    <i class="fal" [ngClass]="{'fa-sticky-note': sku.note,'fa-plus': !sku.note}" (click)="editNote()"></i>
  </div>
  <div
    class="sku_action sku_action--box"
    [ngClass]="{ 'sku_action--inactive': errorMessage }"
    matTooltip="Add to box"
    [matMenuTriggerFor]="addToBoxMenu"
    [matMenuTriggerData]="{ sku: sku }"
    *ngIf="
      (sku.qty - sku.totalBoxed &&
        canBox &&
        addToBoxMenu &&
        canEdit &&
        status === 'WORKING') ||
     ( status === 'IN_TRANSIT'  && sku.qty - sku.totalBoxed > 0 )||
      status === 'READY_TO_SHIP'||
      status === 'CHECKED_IN'||
      status === 'SHIPPED' || (status === 'RECEIVING' && boxContentSource == '2D_BARCODE')
    "
  >
    <i class="fal fa-box-open"></i>
  </div>
  
  <div class="sku_action sku_action--print" *ngIf="sku.qty && printMenu" matTooltip="SKU labels Left to Print" [matMenuTriggerFor]="printMenu"
  [matMenuTriggerData]="{ sku: sku, box: box }">
    <i class="fal fa-print"></i>
    <div class="sku_print-number" *ngIf="!box"
      [matTooltip]="(sku.qty - sku.printedCount).toString().length  >= 3 ?  (sku.qty - sku.printedCount)  : ''">
      {{ (sku.qty - sku.printedCount) | number}}
    </div>
  </div>

  <div *ngIf="showDetail && !shipmentSkuBoxScan" class="sku_details">
    <span class="sku_prep-details" *ngIf="showAmazonDetail">{{
      sku.prep
    }}</span>
    <span
      class="sku_detail-devider"
      *ngIf="showAmazonDetail && sku.prep && sku.expirable"
    ></span>
    <app-sku-date
      *ngIf="sku.expirable && !shipmentSkuBoxScan"
      [expDate]="sku.expDate"
      (expDateEvent)="expDateEvent.emit($event)"
    ></app-sku-date>
  </div>
  <div class="sku_remaining" *ngIf="!box && headerService.useBinLocation && status === 'DRAFT'"><span class="text-gray">Remaining Days : </span>{{(sku.remainingDays || 0) | number: '1.0-0'}}</div>
  <div
    class="sku_more-actions"
    [matMenuTriggerFor]="actionMenu"
    [matMenuTriggerData]="{ sku: sku, box: box }"
    *ngIf="actionMenu && canEdit"
    [matTooltip]="'Options'"
  >
    <i class="far fa-ellipsis-v"></i>
  </div>
  <div *ngIf="showMappedProduct && sku.mappedProducts" class="sku_mapped-product" [matTooltip]="sku.mappedProducts">
    <span><span class="text-gray">Mapped Products:</span> {{sku.mappedProducts}}</span>
  </div>
  <div
    *ngIf="skuRemove"
    class="sku_action sku_action--error"
    (click)="removeSku(sku)"
  >
    <i class="far fa-times-circle fa-1x"></i>
  </div>
  <div class="scan-qty" *ngIf="shipmentSkuBoxScan">
    <span class="qty-input-label">Qty</span>
    <input 
      class="qty-input" 
      type="number" 
      min="1" 
      name="skuqty" 
      id="skuqty" 
      #skuqty
      [(ngModel)]="skuScanQty" 
      [class.is-invalid]="invalidSkuQty && skuqty.dirty"
      (ngModelChange)="onQtyChange($event);">
  </div>

</div>